import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import LOgo from "../../assets/Ntact.png";
import { formatAuditComment } from "../utils/commentFormatter";

// PDF styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    paddingHorizontal: 10, // reduce this from 20–40 if needed
    paddingVertical: 10,
    // padding: 10,
    fontSize: 12,
    fontFamily: "Helvetica",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  logo: { width: 80, height: 40, marginBottom: 10 },
  title: { fontSize: 18, fontWeight: "bold" },
  section: { marginBottom: 10 },
  grid: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
    flexWrap: "wrap",
    gap: 4,
  },
  gridItem: { border: "1px solid #ccc", padding: 5, width: "30%" },
  gridItemFull: { border: "1px solid #ccc", padding: 5, width: "100%" },
  gridItemHalf: { border: "1px solid #ccc", padding: 5, width: "48%" },
  table: { border: "1px solid #ccc", marginBottom: 10 },
  tableRow: {
    flexDirection: "row",
    borderBottom: "1px solid #ccc",
    padding: 1,
  },
  tableCell: {
    padding: 2,
    flex: 1,
    textAlign: "center",
    fontSize: 14,
    margin: 1,
  },
  tableHeader: { backgroundColor: "#f0f0f0", fontWeight: "bold" },
  checklist: {
    marginBottom: 10,
    border: "1px solid #ccc",
    padding: 10,
    backgroundColor: "#fff",
  },
  checklistItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 5,
    borderBottom: "1px solid #ccc",
    alignItems: "center",
  },
  checklistText: {
    fontSize: 12,
    fontWeight: "normal",
    textTransform: "uppercase",
  },
  radioContainer: { flexDirection: "row", alignItems: "center" },
  radioButton: {
    width: 10,
    height: 10,
    borderRadius: 10,
    border: "2px solid #ccc",
    marginLeft: 5,
    padding: 1,
  },
  radioButtonSelectedYes: { backgroundColor: "#28a745" },
  radioButtonSelectedNo: { backgroundColor: "#dc3545" },
  radioButtonSelectedNA: { backgroundColor: "#6c757d" },
  radioText: { fontSize: 12, marginLeft: 5, marginRight: 10 },
  note: { border: "1px solid #ccc", padding: 10, marginBottom: 10 },
  comments: {
    border: "1px solid #ccc",
    padding: 10,
    marginBottom: 20,
    marginTop: 10,
  },
  signatureGrid: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 20,
  },
  signatureItem: { border: "1px solid #ccc", padding: 5, width: "48%" },
  underline: {
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    marginVertical: 5,
  },
});
// const renderChecklistImages = (images, prefix) => {
//   const filtered = images.filter(item => item.question.startsWith(prefix));
//   if (!filtered.length) return null;

//   // Extract clean section title
//   const sectionTitle = prefix.replace(/[-:]+$/, '').trim();

//   return (
//     <View style={{ marginTop: 10 }}>
//       {/* ✅ Section Header */}
//       <Text
//         style={{
//           textAlign: 'center',
//           backgroundColor: '#f0f0f0',
//           padding: 6,
//           marginBottom: 8,
//           fontWeight: 'bold',
//           fontSize: 11,
//           borderWidth: 1,
//           borderColor: '#ccc',
//         }}
//       >
//         SECTION: {sectionTitle.toUpperCase()}
//       </Text>

//       {/* ✅ Card Grid */}
//       <View
//         style={{
//           flexDirection: 'row',
//           flexWrap: 'wrap',
//           justifyContent: 'flex-start',
//         }}
//       >
//         {filtered.map((item, idx) => (
//           <View
//             key={idx}
//             style={{
//               flexGrow: 1,
//               flexShrink: 1,
//               flexBasis: '30%',
//               maxWidth: '32%',
//               marginRight: '2%',
//               marginBottom: 10,
//               borderWidth: 1,
//               borderColor: '#ccc',
//               borderRadius: 5,
//               backgroundColor: '#fff',
//               padding: 6,
//             }}
//           >
//             {/* Question */}
//             <Text
//               style={{
//                 fontSize: 9,
//                 fontWeight: 'bold',
//                 marginBottom: 4,
//               }}
//             >
//               {item.question.replace(prefix + ' ', '')}
//             </Text>

//             {/* Images */}
//             {item.urls && item.urls.length > 0 ? (
//               item.urls.map((url, i) => (
//                 <Image
//                   key={i}
//                   source={{ uri: url }}
//                   style={{
//                     alignSelf: 'center',
//                     width: 95,
//                     height: 75,
//                     borderWidth: 1,
//                     borderColor: '#ccc',
//                     borderRadius: 4,
//                     marginBottom: 4,
//                     objectFit: 'contain',
//                   }}
//                 />
//               ))
//             ) : (
//               <Text
//                 style={{
//                   fontSize: 8,
//                   color: '#777',
//                   marginBottom: 4,
//                   textAlign: 'center',
//                 }}
//               >
//                 No image
//               </Text>
//             )}

//             {/* Comment */}
//             <Text style={{ fontSize: 8, lineHeight: 1.3 }}>
//               <Text style={{ fontWeight: 'bold' }}>Comment: </Text>
//               {item.comment || 'N/A'}
//             </Text>
//           </View>
//         ))}
//       </View>
//     </View>
//   );
// };

const renderChecklistImages = (images, prefix) => {
  const filtered = images.filter((item) => item.question.startsWith(prefix));
  if (!filtered.length) return null;

  const sectionTitle = prefix.replace(/[-:]+$/, "").trim();

  return (
    <View wrap={false} style={{ marginTop: 10 }}>
      <View >
        {/* SECTION HEADER */}
        <Text
          minPresenceAhead={80}
          style={{
            textAlign: "center",
            backgroundColor: "#f0f0f0",
            padding: 6,
            marginBottom: 8,
            fontWeight: "bold",
            fontSize: 13,
            borderWidth: 1,
            borderColor: "#ccc",
          }}
        >
          SECTION: {sectionTitle.toUpperCase()}
        </Text>

        {/* GRID */}
        <View
          style={{
            flexDirection: "row",
            flexWrap: "wrap",
          }}
        >
          {filtered.map((item, idx) => {
            const imgCount = item.urls?.length || 0;
            // Smart sizing: fewer images = larger, many images = smaller grid
            const imgWidth = imgCount <= 3 ? 220 : imgCount <= 6 ? 160 : 130;
            const imgHeight = imgCount <= 3 ? 160 : imgCount <= 6 ? 120 : 100;

            return (
            <View
              key={idx}
              wrap={false}
              style={{
                width: "100%",
                marginRight: "2%",
                marginBottom: 10,
                borderWidth: 1,
                borderColor: "#ccc",
                borderRadius: 5,
                backgroundColor: "#fff",
                padding: 6,
              }}
            >
              {/* QUESTION — stays with at least first image row */}
              <Text
                style={{
                  fontSize: 14,
                  fontWeight: "bold",
                  marginBottom: 4,
                }}
              >
                {item.question.replace(prefix + " ", "")}
              </Text>

              {/* IMAGES */}
              {imgCount > 0 && (
                <View
                  style={{
                    flexDirection: "row",
                    flexWrap: "wrap",
                    marginTop: 4,
                  }}
                >
                  {item.urls.map((url, i) => (
                    <Image
                      key={i}
                      source={{ uri: url }}
                      style={{
                        width: imgWidth,
                        height: imgHeight,
                        objectFit: "contain",
                        marginRight: 8,
                        marginBottom: 8,
                        borderWidth: 1,
                        borderColor: "#ccc",
                        borderRadius: 4,
                      }}
                    />
                  ))}
                </View>
              )}

              {/* COMMENT */}
              <Text style={{ fontSize: 12, lineHeight: 1.3 }}>
                <Text style={{ fontWeight: "bold" }}>Comment: </Text>
                {item.comment || "N/A"}
              </Text>
            </View>
            );
          })}
        </View>
      </View>
    </View>
  );
};
export const ShpPDFDocument = ({
  imagesarray,
  additionalnote,
  uploadedimages,
  companylist,
  signpreview,
  pm_name,
  safetyItemImages,
  observerName,
  filledDate,
  signatureDate,
  projectNumber,
  location,
  supervisorSignature,
  empName,
  empId,
  jobDescription,
  jobId,
  ppeItems,
  preJobPlanningItems,
  siteSafetyItems,
  workEnvironmentItems,
  workingAtHeightsItems,
  toolsElectricalItems,
  weldingGasItems,
  excavationItems,
  subcontractorItems,
  emergencyPlanItems,
  infractions,
  commentImages,
  commentImageUrls,
  pm_data,
  signPreviews,
  signOffNotes,
}) => {
  const pmNameMap = {};
  (companylist || []).forEach((item) => {
    const id = item.projectManager?.pm_id;
    const name = item.projectManager?.pm_name;
    if (id) pmNameMap[id] = name;
  });
  const formattedAdditionalComment = formatAuditComment(additionalnote?.[0]?.answer || "");

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        {/* <Page size={{ width: 1000, height: 595 }} style={styles.page} wrap={false}> */}
        {/* Header */}
        <View style={styles.header}>
          <Image src={LOgo} style={styles.logo} />
          <Text style={styles.title}>HEALTH SAFETY & ENVIRONMENTAL</Text>
          <View style={{ width: 100 }} />
        </View>

        {/* Document Info */}
        <View style={styles.grid}>
          <View>
            <Text style={{ fontWeight: "bold" }}>Document Name:</Text>
            <Text>SAFETY AND HEALTH PRIMARY </Text>
            <Text>AUDIT FORM</Text>
          </View>
          <View style={{ marginBottom: 4 }}>
            <Text style={{ fontWeight: "bold" }}>Section:</Text>
            <Text>HSE-18</Text>
          </View>
          <View style={{ alignItems: "flex-end" }}>
            <Text style={{ fontWeight: "bold" }}>Revision:2</Text>

            {/* <Text style={{ fontWeight: "bold" }}>Date:{filledDate}</Text> */}

            <Text style={{ fontWeight: "bold" }}>Document Number: 18-5-D</Text>
          </View>
        </View>
        <View style={styles.underline} />

        {/* Modal Header */}
        <View
          style={[
            styles.section,
            {
              textAlign: "center",
              borderBottom: "1px solid #ccc",
              paddingBottom: 5,
              marginTop: 4,
            },
          ]}
        >
          <Text style={{ fontSize: 16, fontWeight: "bold" }}>
            SAFETY AND HEALTH PRIMARY AUDIT FORM
          </Text>
        </View>

        {imagesarray?.auditors?.length > 0 && (
          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap", // ✅ multiple boxes per row
              justifyContent: "flex-start", // ✅ neatly aligned to left
            }}
          >
            {imagesarray.auditors.map((auditor, index) => (
              <View
                key={index}
                wrap={false}
                style={{
                  width: "31%", // ✅ 3 per row
                  marginRight: "2%",
                  marginBottom: 10,
                  padding: 8,
                  borderWidth: 1,
                  borderColor: "#9CA3AF",
                  borderRadius: 5,
                  backgroundColor: "#fff",
                  flexDirection: "column",
                }}
              >
                {/* Auditor Name */}
                <Text style={{ fontWeight: "bold", marginBottom: 2 }}>
                  Auditor Name:
                </Text>
                <Text style={{ marginBottom: 5 }}>
                  {auditor.auditorName || "N/A"}
                </Text>
                <View
                  style={{
                    height: 1,
                    backgroundColor: "#9CA3AF",
                    marginBottom: 5,
                  }}
                />

                {/* Designation */}
                <Text style={{ fontWeight: "bold", marginBottom: 2 }}>
                  Designation:
                </Text>
                <Text style={{ marginBottom: 5 }}>
                  {auditor.designation || "N/A"}
                </Text>
                <View
                  style={{
                    height: 1,
                    backgroundColor: "#9CA3AF",
                    marginBottom: 5,
                  }}
                />

                {/* Signature */}
                <Text style={{ fontWeight: "bold", marginBottom: 2 }}>
                  Signature:
                </Text>
                {auditor.url ? (
                  <Image
                    source={{ uri: auditor.url.base64_data }}
                    style={{
                      alignSelf: "flex-start",
                      width: 160,
                      height: 50,
                      objectFit: "contain",
                      borderWidth: 1,
                      borderColor: "#D1D5DB",
                      borderRadius: 4,
                      backgroundColor: "#fff",
                      marginTop: 4,
                    }}
                  />
                ) : (
                  <Text style={{ fontStyle: "italic", color: "#6B7280" }}>
                    No signature available
                  </Text>
                )}
              </View>
            ))}
          </View>
        )}

        <View style={styles.grid}>
          <View style={styles.gridItemHalf}>
            <Text style={{ fontWeight: "bold" }}>Date of Audit:</Text>
            <Text>{filledDate}</Text>
          </View>
          {/* COMPANY from companylist[0] */}
        </View>
        <View wrap={false} style={{ flexDirection: "row", marginBottom: 8 }}>
          {/* COMPANY */}
          <View
            style={{
              width: "33.33%",
              borderWidth: 1,
              borderColor: "#9CA3AF",
              padding: 6,
            }}
          >
            <Text style={{ fontWeight: "bold" }}>Company:</Text>
            <Text>{companylist?.[0]?.company?.name || "-"}</Text>
          </View>

          {/* EMPLOYEE */}
          <View
            style={{
              width: "33.33%",
              borderWidth: 1,
              borderColor: "#9CA3AF",
              padding: 6,
            }}
          >
            <Text style={{ fontWeight: "bold" }}>Employee:</Text>
            <Text>
              {empName} ({empId})
            </Text>
          </View>

          {/* JOB */}
          <View
            style={{
              width: "33.33%",
              borderWidth: 1,
              borderColor: "#9CA3AF",
              padding: 6,
            }}
          >
            <Text style={{ fontWeight: "bold" }}>Job:</Text>
            <Text>
              {jobDescription} #{jobId}
            </Text>
          </View>
        </View>

        {companylist?.slice(1).map((item, idx) => (
          <View
            key={idx}
            wrap={false}
            style={{
              flexDirection: "row",
              marginBottom: 8,
            }}
          >
            {/* COMPANY */}
            <View
              style={{
                width: "33%",
                borderWidth: 1,
                borderColor: "#9CA3AF",
                padding: 6,
              }}
            >
              <Text style={{ fontWeight: "bold" }}>Company:</Text>
              <Text>{item?.company?.name}</Text>
            </View>

            {/* EMPLOYEE */}
            <View
              style={{
                width: "33%",
                borderWidth: 1,
                borderColor: "#9CA3AF",
                padding: 6,
              }}
            >
              <Text style={{ fontWeight: "bold" }}>Employee:</Text>
              <Text>
                {item?.employee?.emp_name} ({item?.employee?.emp_id})
              </Text>
            </View>

            {/* JOB */}
            <View
              style={{
                width: "33%",
                borderWidth: 1,
                borderColor: "#9CA3AF",
                padding: 6,
              }}
            >
              <Text style={{ fontWeight: "bold" }}>Job:</Text>
              <Text> #{item?.job?.job_num}</Text>
            </View>
          </View>
        ))}

        <View style={{ marginTop: 15 }}>
          {/* Row 1: Section 1 & 2 */}
          <View
          wrap={false}
            style={{
              marginBottom: 20,
            }}
          >
            {/* Section 1 */}
            <View
              wrap={false}
              style={{
                width: "100%",
                border: "1px solid #ccc",
                backgroundColor: "#fff",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Text
                minPresenceAhead={120}
                style={{
                  textAlign: "center",
                  backgroundColor: "#f0f0f0",
                  padding: 5,
                  fontSize: 14,
                  fontWeight: "bold",
                }}
              >
                SECTION 1: PPE (Personal Protective Equipment)
              </Text>
              <View style={[styles.tableRow, styles.tableHeader]}>
                <Text style={[styles.tableCell, { flex: 2 }]}>
                  Item Description
                </Text>
                <Text style={styles.tableCell}>YES</Text>
                <Text style={styles.tableCell}>NO</Text>
                <Text style={styles.tableCell}>N/A</Text>
              </View>
              {ppeItems.map((item, index) => (
                <View key={index} style={styles.tableRow} wrap={false}>
                  <Text
                    style={[styles.tableCell, { flex: 2, textAlign: "left" }]}
                  >
                    {item.question.replace("PPE - ", "")}
                  </Text>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "YES" && styles.radioButtonSelectedYes,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "NO" && styles.radioButtonSelectedNo,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "N/A" && styles.radioButtonSelectedNA,
                      ]}
                    />
                  </View>
                </View>
              ))}
            </View>
          </View>

          {renderChecklistImages(safetyItemImages, "PPE -")}

          <View
            style={{
              marginBottom: 20,
            }}
          >
            {/* Section 2 */}
            <View
              wrap={false}
              style={{
                width: "100%",
                border: "1px solid #ccc",
                backgroundColor: "#fff",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Text
                minPresenceAhead={120}
                style={{
                  textAlign: "center",
                  backgroundColor: "#f0f0f0",
                  padding: 5,
                  fontSize: 14,
                  fontWeight: "bold",
                }}
              >
                SECTION 2: Pre-Job Planning & Training
              </Text>
              <View style={[styles.tableRow, styles.tableHeader]}>
                <Text style={[styles.tableCell, { flex: 2 }]}>
                  Item Description
                </Text>
                <Text style={styles.tableCell}>YES</Text>
                <Text style={styles.tableCell}>NO</Text>
                <Text style={styles.tableCell}>N/A</Text>
              </View>
              {preJobPlanningItems.map((item, index) => (
                <View key={index} style={styles.tableRow} wrap={false}>
                  <Text
                    style={[styles.tableCell, { flex: 2, textAlign: "left" }]}
                  >
                    {item.question.replace("Pre-Job Planning - ", "")}
                  </Text>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "YES" && styles.radioButtonSelectedYes,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "NO" && styles.radioButtonSelectedNo,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "N/A" && styles.radioButtonSelectedNA,
                      ]}
                    />
                  </View>
                </View>
              ))}
            </View>
          </View>

          {renderChecklistImages(safetyItemImages, "Pre-Job Planning -")}

          {/* Row 2: Section 3 & 4 */}
          <View
            style={{
              marginBottom: 20,
            }}
          >
            {/* Section 3 */}
            <View
              wrap={false}
              style={{
                width: "100%",
                border: "1px solid #ccc",
                backgroundColor: "#fff",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Text
                minPresenceAhead={120}
                style={{
                  textAlign: "center",
                  backgroundColor: "#f0f0f0",
                  padding: 5,
                  fontSize: 14,
                  fontWeight: "bold",
                }}
              >
                SECTION 3: Site Safety
              </Text>
              <View style={[styles.tableRow, styles.tableHeader]}>
                <Text style={[styles.tableCell, { flex: 2 }]}>
                  Item Description
                </Text>
                <Text style={styles.tableCell}>YES</Text>
                <Text style={styles.tableCell}>NO</Text>
                <Text style={styles.tableCell}>N/A</Text>
              </View>
              {siteSafetyItems.map((item, index) => (
                <View key={index} style={styles.tableRow} wrap={false}>
                  <Text
                    style={[styles.tableCell, { flex: 2, textAlign: "left" }]}
                  >
                    {item.question.replace("Site Safety - ", "")}
                  </Text>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "YES" && styles.radioButtonSelectedYes,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "NO" && styles.radioButtonSelectedNo,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "N/A" && styles.radioButtonSelectedNA,
                      ]}
                    />
                  </View>
                </View>
              ))}
            </View>
          </View>

          {renderChecklistImages(safetyItemImages, "Site Safety -")}

          <View
            style={{
              marginBottom: 20,
            }}
          >
            {/* Section 4 */}
            <View
              wrap={false}
              style={{
                width: "100%",
                border: "1px solid #ccc",
                backgroundColor: "#fff",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Text
                minPresenceAhead={120}
                style={{
                  textAlign: "center",
                  backgroundColor: "#f0f0f0",
                  padding: 5,
                  fontSize: 14,
                  fontWeight: "bold",
                }}
              >
                SECTION 4: Work Environment
              </Text>
              <View style={[styles.tableRow, styles.tableHeader]}>
                <Text style={[styles.tableCell, { flex: 2 }]}>
                  Item Description
                </Text>
                <Text style={styles.tableCell}>YES</Text>
                <Text style={styles.tableCell}>NO</Text>
                <Text style={styles.tableCell}>N/A</Text>
              </View>
              {workEnvironmentItems.map((item, index) => (
                <View key={index} style={styles.tableRow} wrap={false}>
                  <Text
                    style={[styles.tableCell, { flex: 2, textAlign: "left" }]}
                  >
                    {item.question.replace("Work Environment - ", "")}
                  </Text>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "YES" && styles.radioButtonSelectedYes,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "NO" && styles.radioButtonSelectedNo,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "N/A" && styles.radioButtonSelectedNA,
                      ]}
                    />
                  </View>
                </View>
              ))}
            </View>
          </View>

          {renderChecklistImages(safetyItemImages, "Work Environment -")}

          {/* Row 3: Section 5 & 6 */}
          <View
            style={{
              marginBottom: 20,
            }}
          >
            {/* Section 5 */}
            <View
              wrap={false}
              style={{
                width: "100%",
                border: "1px solid #ccc",
                backgroundColor: "#fff",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Text
                minPresenceAhead={120}
                style={{
                  textAlign: "center",
                  backgroundColor: "#f0f0f0",
                  padding: 5,
                  fontSize: 14,
                  fontWeight: "bold",
                }}
              >
                SECTION 5: Working at Heights
              </Text>
              <View style={[styles.tableRow, styles.tableHeader]}>
                <Text style={[styles.tableCell, { flex: 2 }]}>
                  Item Description
                </Text>
                <Text style={styles.tableCell}>YES</Text>
                <Text style={styles.tableCell}>NO</Text>
                <Text style={styles.tableCell}>N/A</Text>
              </View>
              {workingAtHeightsItems.map((item, index) => (
                <View key={index} style={styles.tableRow} wrap={false}>
                  <Text
                    style={[styles.tableCell, { flex: 2, textAlign: "left" }]}
                  >
                    {item.question.replace("Working at Heights - ", "")}
                  </Text>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "YES" && styles.radioButtonSelectedYes,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "NO" && styles.radioButtonSelectedNo,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "N/A" && styles.radioButtonSelectedNA,
                      ]}
                    />
                  </View>
                </View>
              ))}
            </View>
          </View>

          {renderChecklistImages(safetyItemImages, "Working at Heights -")}

          <View
            style={{
              marginBottom: 20,
            }}
          >
            {/* Section 6 */}
            <View
              wrap={false}
              style={{
                width: "100%",
                border: "1px solid #ccc",
                backgroundColor: "#fff",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Text
                minPresenceAhead={120}
                style={{
                  textAlign: "center",
                  backgroundColor: "#f0f0f0",
                  padding: 5,
                  fontSize: 14,
                  fontWeight: "bold",
                }}
              >
                SECTION 6: Tools Electrical
              </Text>
              <View style={[styles.tableRow, styles.tableHeader]}>
                <Text style={[styles.tableCell, { flex: 2 }]}>
                  Item Description
                </Text>
                <Text style={styles.tableCell}>YES</Text>
                <Text style={styles.tableCell}>NO</Text>
                <Text style={styles.tableCell}>N/A</Text>
              </View>
              {toolsElectricalItems.map((item, index) => (
                <View key={index} style={styles.tableRow} wrap={false}>
                  <Text
                    style={[styles.tableCell, { flex: 2, textAlign: "left" }]}
                  >
                    {item.question.replace("Tools Electrical - ", "")}
                  </Text>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "YES" && styles.radioButtonSelectedYes,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "NO" && styles.radioButtonSelectedNo,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "N/A" && styles.radioButtonSelectedNA,
                      ]}
                    />
                  </View>
                </View>
              ))}
            </View>
          </View>

          {renderChecklistImages(safetyItemImages, "Tools Electrical -")}

          {/* Row 4: Section 7 & 8 */}
          <View
            style={{
              marginBottom: 20,
            }}
          >
            {/* Section 7 */}
            <View
              wrap={false}
              style={{
                width: "100%",
                border: "1px solid #ccc",
                backgroundColor: "#fff",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Text
                minPresenceAhead={120}
                style={{
                  textAlign: "center",
                  backgroundColor: "#f0f0f0",
                  padding: 5,
                  fontSize: 14,
                  fontWeight: "bold",
                }}
              >
                SECTION 7: Welding Gas
              </Text>
              <View style={[styles.tableRow, styles.tableHeader]}>
                <Text style={[styles.tableCell, { flex: 2 }]}>
                  Item Description
                </Text>
                <Text style={styles.tableCell}>YES</Text>
                <Text style={styles.tableCell}>NO</Text>
                <Text style={styles.tableCell}>N/A</Text>
              </View>
              {weldingGasItems.map((item, index) => (
                <View key={index} style={styles.tableRow} wrap={false}>
                  <Text
                    style={[styles.tableCell, { flex: 2, textAlign: "left" }]}
                  >
                    {item.question.replace("Welding Gas - ", "")}
                  </Text>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "YES" && styles.radioButtonSelectedYes,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "NO" && styles.radioButtonSelectedNo,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "N/A" && styles.radioButtonSelectedNA,
                      ]}
                    />
                  </View>
                </View>
              ))}
            </View>
          </View>

          {renderChecklistImages(safetyItemImages, "Welding Gas -")}

          <View
            style={{
              marginBottom: 20,
            }}
          >
            {/* Section 8 */}
            <View
              wrap={false}
              style={{
                width: "100%",
                border: "1px solid #ccc",
                backgroundColor: "#fff",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Text
                minPresenceAhead={120}
                style={{
                  textAlign: "center",
                  backgroundColor: "#f0f0f0",
                  padding: 5,
                  fontSize: 14,
                  fontWeight: "bold",
                }}
              >
                SECTION 8: Excavation
              </Text>
              <View style={[styles.tableRow, styles.tableHeader]}>
                <Text style={[styles.tableCell, { flex: 2 }]}>
                  Item Description
                </Text>
                <Text style={styles.tableCell}>YES</Text>
                <Text style={styles.tableCell}>NO</Text>
                <Text style={styles.tableCell}>N/A</Text>
              </View>
              {excavationItems.map((item, index) => (
                <View key={index} style={styles.tableRow} wrap={false}>
                  <Text
                    style={[styles.tableCell, { flex: 2, textAlign: "left" }]}
                  >
                    {item.question.replace("Excavation - ", "")}
                  </Text>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "YES" && styles.radioButtonSelectedYes,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "NO" && styles.radioButtonSelectedNo,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "N/A" && styles.radioButtonSelectedNA,
                      ]}
                    />
                  </View>
                </View>
              ))}
            </View>
          </View>

          {renderChecklistImages(safetyItemImages, "Excavation -")}

          {/* Row 5: Section 9 & 10 */}
          <View
            style={{
              marginBottom: 20,
            }}
          >
            {/* Section 9 */}
            <View
              wrap={false}
              style={{
                width: "100%",
                border: "1px solid #ccc",
                backgroundColor: "#fff",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Text
                minPresenceAhead={120}
                style={{
                  textAlign: "center",
                  backgroundColor: "#f0f0f0",
                  padding: 5,
                  fontSize: 14,
                  fontWeight: "bold",
                }}
              >
                SECTION 9: Subcontractor Safety
              </Text>
              <View style={[styles.tableRow, styles.tableHeader]}>
                <Text style={[styles.tableCell, { flex: 2 }]}>
                  Item Description
                </Text>
                <Text style={styles.tableCell}>YES</Text>
                <Text style={styles.tableCell}>NO</Text>
                <Text style={styles.tableCell}>N/A</Text>
              </View>
              {subcontractorItems.map((item, index) => (
                <View key={index} style={styles.tableRow} wrap={false}>
                  <Text
                    style={[styles.tableCell, { flex: 2, textAlign: "left" }]}
                  >
                    {item.question.replace("Subcontractor - ", "")}
                  </Text>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "YES" && styles.radioButtonSelectedYes,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "NO" && styles.radioButtonSelectedNo,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "N/A" && styles.radioButtonSelectedNA,
                      ]}
                    />
                  </View>
                </View>
              ))}
            </View>
          </View>

          {renderChecklistImages(safetyItemImages, "Subcontractor -")}

          <View
            style={{
              marginBottom: 20,
            }}
          >
            {/* Section 10 */}
            <View
              wrap={false}
              style={{
                width: "100%",
                border: "1px solid #ccc",
                backgroundColor: "#fff",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Text
                minPresenceAhead={120}
                style={{
                  textAlign: "center",
                  backgroundColor: "#f0f0f0",
                  padding: 5,
                  fontSize: 14,
                  fontWeight: "bold",
                }}
              >
                SECTION 10: Emergency Action Plan
              </Text>
              <View style={[styles.tableRow, styles.tableHeader]}>
                <Text style={[styles.tableCell, { flex: 2 }]}>
                  Item Description
                </Text>
                <Text style={styles.tableCell}>YES</Text>
                <Text style={styles.tableCell}>NO</Text>
                <Text style={styles.tableCell}>N/A</Text>
              </View>
              {emergencyPlanItems.map((item, index) => (
                <View key={index} style={styles.tableRow} wrap={false}>
                  <Text
                    style={[styles.tableCell, { flex: 2, textAlign: "left" }]}
                  >
                    {item.question.replace("Emergency Plan - ", "")}
                  </Text>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "YES" && styles.radioButtonSelectedYes,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "NO" && styles.radioButtonSelectedNo,
                      ]}
                    />
                  </View>
                  <View
                    style={[
                      styles.tableCell,
                      { justifyContent: "center", alignItems: "center" },
                    ]}
                  >
                    <View
                      style={[
                        styles.radioButton,
                        item.answer === "N/A" && styles.radioButtonSelectedNA,
                      ]}
                    />
                  </View>
                </View>
              ))}
            </View>
          </View>

          {renderChecklistImages(safetyItemImages, "Emergency Plan -")}
        </View>

        {/* <View break style={{ marginTop: 40, borderWidth: 1, borderColor: '#ccc', backgroundColor: '#fff', padding: 10 }}> */}
        {/* <Text style={{ textAlign: 'center', backgroundColor: '#f0f0f0', padding: 5, marginBottom: 10, fontWeight: 'bold' }}>
    Details of Infractions / Notes
  </Text>

  <View style={{ flexDirection: 'row', borderBottomWidth: 1, borderColor: '#ccc', paddingVertical: 5 }}>
    <Text style={{ flex: 1, fontWeight: 'bold' }}>Section</Text>
    <Text style={{ flex: 1, fontWeight: 'bold' }}>Item</Text>
    <Text style={{ flex: 1, fontWeight: 'bold' }}>Corrective Action</Text>
    <Text style={{ flex: 2, fontWeight: 'bold', textAlign: 'center' }}>Completed (Y/N)</Text>
  </View> */}

        {/*  
  {infractions.length > 0 ? (
    infractions.map((infraction, index) => (
      <View key={index} style={{ flexDirection: 'row', borderBottomWidth: 1, borderColor: '#eee', paddingVertical: 5, alignItems: 'center' }}>
        <Text style={{ flex: 1 }}>{infraction.section}</Text>
        <Text style={{ flex: 1 }}>{infraction.item}</Text>
        <Text style={{ flex: 1 }}>{infraction.correctiveAction}</Text>
        <View style={{ flex: 2, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
          <Text style={{ marginHorizontal: 5 }}>Y</Text>
          <View style={{ width: 16, height: 16, borderRadius: 8, borderWidth: 1, borderColor: '#ccc', backgroundColor: infraction.completed === 'Y' ? 'green' : 'white', marginHorizontal: 5 }} />
          <Text style={{ marginHorizontal: 5 }}>N</Text>
          <View style={{ width: 16, height: 16, borderRadius: 8, borderWidth: 1, borderColor: '#ccc', backgroundColor: infraction.completed === 'N' ? 'red' : 'white', marginHorizontal: 5 }} />
        </View>
      </View>
    ))
  ) : (
    <View style={{ paddingVertical: 10 }}>
      <Text>No infractions reported</Text>
    </View>
  )} */}

        {/* Images Grid */}
        {/* <View style={{ flexDirection: 'row', flexWrap: 'wrap', marginTop: 20, justifyContent: 'flex-start' }}>
    {uploadedimages?.map((image, index) => {
      const relatedInfraction = infractions.find(
        (infraction) => infraction.photo?.file_name === image.filename
      );

      return image?.base64_data ? (
        <View key={index} style={{ width: 120, margin: 5, alignItems: 'center' }}>
          <Image
            source={{ uri: image.base64_data }}
            style={{ width: 120, height: 120, resizeMode: 'contain', borderWidth: 1, borderColor: '#ccc', borderRadius: 8, backgroundColor: '#fff' }}
          />
          {relatedInfraction && (
            <Text
              style={{
                marginTop: 5,
              
               
                color: '#fff',
           
                fontSize: 12,
                fontWeight: '500',
                textAlign: 'center',
              }}
            >
              {relatedInfraction.section}
            </Text>
          )}
        </View>
      ) : null;
    })}
  </View> */}
        {/* </View> */}
        <View>
          {/* {renderChecklistImages(safetyItemImages, "Tools Electrical -")} */}
        </View>
        {additionalnote?.[0]?.answer ? (
          // NOTE: do NOT set wrap={false} here — long comments must be
          // allowed to flow across pages, otherwise react-pdf either
          // overflows or silently hangs.
          <View
            style={{
              alignSelf: "stretch",
              paddingVertical: 6,
              paddingHorizontal: 8,
              borderRadius: 3,
              marginTop: 6,
              marginBottom: 6,
              borderWidth: 1,
              borderColor: "#e0e0e0",
              backgroundColor: "#fdfdfd",
            }}
          >
            <Text
              style={{
                fontWeight: "600",
                fontSize: 13,
                color: "#333",
                marginBottom: 4,
              }}
            >
              Additional Comments
            </Text>

            {formattedAdditionalComment.sections.length > 0 ? (
              <View>
                {formattedAdditionalComment.intro ? (
                  <Text
                    style={{
                      fontSize: 11,
                      color: "#444",
                      lineHeight: 1.45,
                      marginBottom: 4,
                    }}
                  >
                    {formattedAdditionalComment.intro}
                  </Text>
                ) : null}
                {formattedAdditionalComment.sections.map((section, sectionIdx) => (
                  <View key={sectionIdx} style={{ marginBottom: 4 }}>
                    <Text style={{ fontSize: 11, fontWeight: "bold", color: "#333", marginBottom: 2 }}>
                      {section.title}
                    </Text>
                    {section.items.map((item, itemIdx) => (
                      <Text
                        key={itemIdx}
                        style={{
                          fontSize: 10.5,
                          color: "#444",
                          lineHeight: 1.45,
                          marginLeft: 8,
                          marginBottom: 1,
                        }}
                      >
                        {`${itemIdx + 1}. ${item}`}
                      </Text>
                    ))}
                  </View>
                ))}
              </View>
            ) : (
              <Text
                style={{
                  fontSize: 11,
                  color: "#444",
                  lineHeight: 1.45, // must be > 1 (as a ratio) so lines don't overlap
                }}
              >
                {formattedAdditionalComment.fallbackText}
              </Text>
            )}
          </View>
        ) : null}

        {/* Comment Images — render from pre-fetched base64 data URIs so
            @react-pdf/renderer doesn't have to fetch anything at render time.
            This eliminates the slow proxy round-trips and the "missing image"
            problem where react-pdf would silently drop failed fetches. */}
        {commentImageUrls?.length > 0 && (
          <View style={{ marginTop: 6, marginBottom: 6 }}>
            <Text style={{ fontWeight: "bold", fontSize: 12, marginBottom: 4 }}>Comment Images</Text>
            <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
              {commentImageUrls.map((dataUri, i) => (
                <View key={i} style={{ position: "relative", marginRight: 6, marginBottom: 6 }}>
                  <Image
                    src={dataUri}
                    style={{
                      width: 120,
                      height: 120,
                      objectFit: "cover",
                      borderWidth: 1,
                      borderColor: "#ccc",
                      borderRadius: 4,
                    }}
                  />
                  <View
                    style={{
                      position: "absolute",
                      top: 3,
                      left: 3,
                      backgroundColor: "rgba(0,0,0,0.6)",
                      borderRadius: 7,
                      width: 14,
                      height: 14,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        color: "#fff",
                        fontSize: 8,
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      {i + 1}
                    </Text>
                  </View>
                </View>
              ))}
            </View>
          </View>
        )}

        {/* Signatures */}
        <View style={{ flexDirection: "row", gap: 10 }}>
          {/* Auditor Signature */}
          {/* <View style={{ flex: 1, borderWidth: 1, borderColor: '#9CA3AF', padding: 5 }}>
    <Text style={{ fontWeight: 'bold' }}>Auditor Signature:</Text>
    {imagesarray?.[0]?.base64_data && (
      <Image
        source={{ uri: imagesarray[0].base64_data }}
        style={{
          width: 160,
          height: 90,
          resizeMode: 'contain',
          borderWidth: 1,
          borderColor: '#D1D5DB',
          borderRadius: 4,
          backgroundColor: '#fff',
          marginTop: 5,
        }}
      />
    )}
    <View style={{ borderTopWidth: 1, borderColor: '#9CA3AF', marginTop: 5 }} />
    <Text style={{ fontWeight: 'bold', marginTop: 10 }}>Date:</Text>
    <Text>{signatureDate}</Text>
    <View style={{ borderTopWidth: 1, borderColor: '#9CA3AF', marginTop: 5 }} />
  </View> */}

          {/* Project Manager Signature */}
          {/* <View style={{ flex: 1, borderWidth: 1, borderColor: '#9CA3AF', padding: 5 }}>
    <Text style={{ fontWeight: 'bold' }}>Supervisor Signature:</Text>
    {imagesarray?.supervisorurl?.url?.base64_data && (
      <Image
        source={{ uri: imagesarray?.supervisorurl?.url?.base64_data }}
        style={{
          width: 160,
          height: 90,
          resizeMode: 'contain',
          borderWidth: 1,
          borderColor: '#D1D5DB',
          borderRadius: 4,
          backgroundColor: '#fff',
          marginTop: 5,
        }}
      />
    )}
    <View style={{ borderTopWidth: 1, borderColor: '#9CA3AF', marginTop: 5 }} />
    <Text style={{ fontWeight: 'bold', marginTop: 10 }}>Date:</Text>
    <Text>{signatureDate}</Text>
    <View style={{ borderTopWidth: 1, borderColor: '#9CA3AF', marginTop: 5 }} />
  </View> */}
          {/* {signpreview&&  <View style={{ flex: 1, borderWidth: 1, borderColor: '#9CA3AF', padding: 5 }}>
    <Text style={{ fontWeight: 'bold' }}>Project Manager:</Text>
   
      <Image
      source={{ uri: signpreview }}
        style={{
          width: 100,
          height: 30,
          resizeMode: 'contain',
          borderWidth: 1,
          borderColor: '#D1D5DB',
          borderRadius: 4,
          backgroundColor: '#fff',
          marginTop: 5,
        }}
      />
    
  
   
  </View>} */}

          <View style={{ marginTop: 10 }}>
            {Object.entries(pm_data || {}).map(([pmId, status]) => {
              if (status !== "Y") return null;

              const preview = signPreviews?.[pmId];
              if (!preview) return null;

              const pmName = pmNameMap[pmId] || "Project Manager";

              return (
                <View
                  key={pmId}
                  style={{
                    borderWidth: 1,
                    borderColor: "#9CA3AF",
                    padding: 5,
                    marginBottom: 8,
                  }}
                >
                  <Text style={{ fontWeight: "bold" }}>
                    Project Manager: {pmName}
                  </Text>

                  <Image
                    source={{ uri: preview }}
                    style={{
                      width: 160,
                      height: 50,
                      objectFit: "contain",
                      borderWidth: 1,
                      borderColor: "#D1D5DB",
                      borderRadius: 4,
                      backgroundColor: "#fff",
                      marginTop: 5,
                    }}
                  />

                  {signOffNotes?.[pmId] ? (
                    <View style={{ marginTop: 5 }}>
                      <Text style={{ fontWeight: "bold", fontSize: 10 }}>
                        Sign-off Notes:
                      </Text>
                      <Text style={{ fontSize: 9, color: "#374151", marginTop: 2 }}>
                        {signOffNotes[pmId]}
                      </Text>
                    </View>
                  ) : null}
                </View>
              );
            })}
          </View>
        </View>
      </Page>
    </Document>
  );
};
